export default "data:image/gif;base64,R0lGODlhCgAKAIAAAP///+fv3iH5BAEAAAAALAAAAAAKAAoAAAIRjI8By6zdHlxyVnjjdJt2UAAAOw=="